//components
import AudioMessage from "./AudioMessage";
import Avatar from "./Avatar";
import TextMessage from "./TextMessage";

//tools
import cc from "classcat";
import moment from "moment";

//styles
import styles from "./UserBotMessage.module.css";


const getAuthorName = (message, isCurrentUser) => {
	if (message.type === "bot") return "Carlos";
	if (isCurrentUser) return "You";
	if (message.author_name) return message.author_name;
	return "User";
};

const getReplyAuthorName = (reply_to) => {
	if (reply_to.type === "bot") return "Carlos";
	if (reply_to.user_guid === window.__cng_common.user_guid) return "You";
	if (reply_to.author_name) return reply_to.author_name;
	return "User";
};

const getReplyText = (reply_to) => {
	if (typeof reply_to.text === "string") return reply_to.text;
	return JSON.stringify(reply_to.text);
};

const UserBotMessage = ({ message, isCurrentUser, audioPlayedIdsRef }) => {
	const isCurrentUserMessage = isCurrentUser && message.type === "user";

	return (
		<div
			key={message.id}
			className={cc([
				styles["message"],
				isCurrentUserMessage && styles["message-user"]
			])}>
			<Avatar message={message} isCurrentUser={isCurrentUser} />
			<div
				className={cc([
					styles["message-content"],
					isCurrentUserMessage && styles["message-content-user"]
				])}>
				<div
					className={cc([
						styles["message-triangle"],
						isCurrentUserMessage && styles["message-triangle-user"]
					])}></div>
				<span className={styles["message-author"]}>
					{getAuthorName(message, isCurrentUserMessage)}
				</span>
				{message.reply_to && (
					<div className={styles["reply-container"]}>
						<span className={styles["reply-author"]}>
							{getReplyAuthorName(message.reply_to)}
						</span>
						<span className={styles["reply-text"]}>
							{getReplyText(message.reply_to)}
						</span>
					</div>
				)}
				<div className={styles["message-text-container"]}>
					{message.audio_url || message.type === "bot" ? (
						<AudioMessage
							message={message}
							isCurrentUser={isCurrentUser}
							audioPlayedIdsRef={audioPlayedIdsRef}
						/>
					) : (
						<TextMessage message={message} />
					)}
					<span className={styles["message-time"]}>
						{message.created_at
							? moment(message.created_at).format("HH:mm")
							: ""}
					</span>
				</div>
			</div>
		</div>
	);
};

export default UserBotMessage;
